import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sponsorsRequest, localSponsorsRequest } from './sponsorsReq';

const initialSponsorsState: any = {
    data: [],
    status: 'idle',
    error: null
};

export const fetchSponsors = createAsyncThunk("sponsors/fetchSponsors", async () => {
    try {
        const response = await sponsorsRequest(); // for an API requests
        //const response = await localSponsorsRequest(); // for local data tests
        return [...response.data]
    } catch (err: any) {
        return err.message
    }
})

export const sponsorsSlice = createSlice({
    name: "sponsors",
    initialState: initialSponsorsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSponsors.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = 'fullfiled'
            })
            .addCase(fetchSponsors.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
    }
})

export const getApiSponsors = (state: any) => state.sponsors.data;
export const getApiSponsorsStatus = (state: any) => state.sponsors.status;
export const getApiSponsorsErrors = (state: any) => state.sponsors.error;

export default sponsorsSlice.reducer;